"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.has = void 0;
function has(property, allowNull = false) {
    if (allowNull) {
        return (value) => value != null && property in value;
    }
    return (value) => value?.[property] != null;
}
exports.has = has;
